import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function CarouselBanner() {
  const navigate = useNavigate();

  const getBackgroundStyle = (imagePath) => ({
    backgroundImage: `url("${imagePath}")`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    height: "100vh",
    width: "100%",
    position: "relative",
    filter: "none",
  });

  const overlayStyle = {
    position: "absolute",
    top: 0,
    left: 0,
    height: "100%",
    width: "100%",
    zIndex: 1,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "#ffffff",
    textAlign: "center",
    padding: "2rem",
  };

  const textStyle = { color: "#ffffff" };

  // Preload images on mount
  useEffect(() => {
    ["/images/cbg1.png", "/images/cbg2.png", "/images/cbg3.png"].forEach((src) => {
      const img = new Image();
      img.src = src;
    });
  }, []);

  return (
    <div
      id="mainCarousel"
      className="carousel slide carousel-fade"
      data-bs-ride="carousel"
      data-bs-interval="5000"
    >
      <div className="carousel-inner">
        {/* Slide 1 */}
        <div className="carousel-item active">
          <div style={getBackgroundStyle("/images/cbg1.png")}>
            <div style={overlayStyle}>
              <div className="container">
                <div className="row justify-content-center">
                  <div className="col-lg-8 col-md-10 col-sm-12">
                    <h1 className="display-5 fw-bold" style={textStyle}>Innovative Solutions</h1>
                    <p className="lead" style={textStyle}>
                      Empowering your business with scalable tech solutions.
                    </p>
                    <p className="d-none d-sm-block" style={textStyle}>
                      At Vizionexl, we build secure, scalable software tailored to modern business needs.
                      Our mission is rooted in innovation and quality.
                    </p>
                    <button className="btn btn-light mt-3" onClick={() => navigate("/what-we-do")}>
                      What We Do
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Slide 2 */}
        <div className="carousel-item">
          <div style={getBackgroundStyle("/images/cbg2.png")}>
            <div style={overlayStyle}>
              <div className="container">
                <div className="row justify-content-center">
                  <div className="col-lg-8 col-md-10 col-sm-12">
                    <h1 className="display-5 fw-bold" style={textStyle}>Our Creations</h1>
                    <p className="lead" style={textStyle}>Built for performance, built for people.</p>
                    <button className="btn btn-light mt-3" onClick={() => navigate("/projects")}>
                      View Projects
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Slide 3 */}
        <div className="carousel-item">
          <div style={getBackgroundStyle("/images/cbg3.png")}>
            <div style={overlayStyle}>
              <div className="container">
                <div className="row justify-content-center">
                  <div className="col-lg-8 col-md-10 col-sm-12">
                    <h1 className="display-5 fw-bold" style={textStyle}>IT-Level Training</h1>
                    <p className="lead" style={textStyle}>
                      Get trained by industry experts to elevate your skills.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Controls */}
      <button
        className="carousel-control-prev"
        type="button"
        data-bs-target="#mainCarousel"
        data-bs-slide="prev"
      >
        <span className="carousel-control-prev-icon" />
      </button>
      <button
        className="carousel-control-next"
        type="button"
        data-bs-target="#mainCarousel"
        data-bs-slide="next"
      >
        <span className="carousel-control-next-icon" />
      </button>
    </div>
  );
}
